import { HeaderNavigation } from 'baseui/header-navigation';
import { useStyles } from '../../../hooks/useStyles';
import { UserMenu } from './UserMenu';
import { PageTitle } from './PageTitle';

export function Navbar() {
  const { theme } = useStyles();

  return (
    <HeaderNavigation
      overrides={{
        Root: {
          style: {
            alignItems: 'center',
            boxSizing: 'border-box',
            paddingRight: theme.sizing.scale500,
            paddingLeft: theme.sizing.scale500,
            columnGap: theme.sizing.scale500,
            minHeight: 'auto',
            paddingTop: theme.sizing.scale300,
            paddingBottom: theme.sizing.scale300,
            [theme.mediaQuery.extraLarge]: {
              minHeight: '60px',
              paddingTop: theme.sizing.scale500,
              paddingBottom: theme.sizing.scale500,
            },
          },
        },
      }}
    >
      <PageTitle />
      <UserMenu />
    </HeaderNavigation>
  );
}
